export default __webpack_public_path__ + "static/media/CNo.76-6.00ece3a9.jpg";